import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Separator from '../components/Separator';
import FeaturedSolutions, { FeaturedItem } from '../components/FeaturedSolutions';
import flyTapPayTall from '../assets/products/fly-tap-pay-tall.png';
import appOndemandFood from '../assets/products/app-ondemand-food.png';
import appQrQuickpayTall from '../assets/products/app-qr-quickpay-tall.png';
import appReserve2 from '../assets/products/app-reserve2.png';

const PoolsideDiningPage = () => {
  const navigate = useNavigate();

  return (
    <div className="page poolsideDiningPage">
      <Header />
      <div className="page-header">Residential Building</div>

      <div className="text-wrapper">
        <div className="top">
          <div className="topic-header">Poolside Dining</div>
          <Separator />
        </div>
        <div className="std-text">
          {"Delight residents with food and beverage at-a-click ordering delivered wherever they are.\n\nEnhance the poolside experience with fast, easy, mobile ordering and payment to drive increased order volume, improve check size and grow F&B revenue."}
        </div>
      </div>

      <FeaturedSolutions>
        <FeaturedItem
          label="IG Fly"
          imgSrc={flyTapPayTall}
          onClick={() => navigate('/solutions/ig-fly')}
        />
        <FeaturedItem
          label="IG OnDemand"
          imgSrc={appOndemandFood}
          onClick={() => navigate('/solutions/ig-on-demand')}
        />
        <FeaturedItem
          label="IG Quick Pay"
          imgSrc={appQrQuickpayTall}
          onClick={() => navigate('/solutions/ig-quick-pay')}
        />
        <FeaturedItem
          label="Reserve"
          imgSrc={appReserve2}
          onClick={() => navigate('/solutions/reserve')}
        />
      </FeaturedSolutions>
    </div>
  );
};

export default PoolsideDiningPage;
